// extracted by mini-css-extract-plugin
export default {"basic-panel":"ModalCompaniesStatusChange_basic-panel__hj+h7","title":"ModalCompaniesStatusChange_title__+5Xta","text":"ModalCompaniesStatusChange_text__2qjuI"};